<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 16 15"
>
  <path
    [attr.fill]="color"
    d="M8.68333 0L6.78533 1.88533L10.9027 6.00267H0V8.664H10.9027L6.78533 12.7813L8.68333 14.6667L16 7.33333L8.68333 0Z"
  />
</svg>
